module.exports = __webpack_public_path__ + "img/dark_logoPixabay.626434d9.png";